import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=89461d44&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=89461d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89461d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89461d44')) {
      api.createRecord('89461d44', component.options)
    } else {
      api.reload('89461d44', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=89461d44&scoped=true&", function () {
      api.rerender('89461d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0pnJQiuDB5k/JS/comp/SearchFilterTokens.vue"
export default component.exports